"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledStatusIndicator = exports.STATUS_INDICATOR_SIZE = exports.STATUS_INDICATOR_BORDER = exports.SMALL_AVATAR = exports.LARGE_AVATAR = exports.InnerBrandAvatarWrapper = exports.InitialsLogo = exports.BrandAvatarWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _polished = require("polished");
var LARGE_AVATAR = exports.LARGE_AVATAR = 40;
var SMALL_AVATAR = exports.SMALL_AVATAR = 24;
var STATUS_INDICATOR_SIZE = exports.STATUS_INDICATOR_SIZE = 6;
var STATUS_INDICATOR_BORDER = exports.STATUS_INDICATOR_BORDER = 1;
var INDICATOR_COLORS = {
  neutral: _colors["default"].neutral500,
  accent: _colors["default"].blue20_60,
  success: _colors["default"].green50,
  warning: _colors["default"].orange50,
  danger: _colors["default"].red50
};
var BrandAvatarWrapper = exports.BrandAvatarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBBrandAvatarstyles__BrandAvatarWrapper",
  componentId: "sc-1hj7ts0-0"
})(["position:relative;width:", ";height:", ";box-sizing:unset;border-radius:3px;&::after{content:'';position:absolute;inset:0;box-shadow:inset 0 0 0 1px rgba(255,255,255,0.2);border-radius:inherit;pointer-events:none;", "}> *{border-radius:", ";}img{height:100%;width:100%;}"], function (_ref) {
  var $size = _ref.$size;
  return $size === 'large' ? "".concat(LARGE_AVATAR, "px") : "".concat(SMALL_AVATAR, "px");
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size === 'large' ? "".concat(LARGE_AVATAR, "px") : "".concat(SMALL_AVATAR, "px");
}, function (_ref3) {
  var $clipPath = _ref3.$clipPath;
  return $clipPath;
}, function (_ref4) {
  var $size = _ref4.$size;
  return $size === 'large' ? '4px' : '3px';
});
var InnerBrandAvatarWrapper = exports.InnerBrandAvatarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBBrandAvatarstyles__InnerBrandAvatarWrapper",
  componentId: "sc-1hj7ts0-1"
})(["overflow:hidden;width:100%;height:100%;background-color:", ";", ""], _colors["default"].white, function (_ref5) {
  var $clipPath = _ref5.$clipPath;
  return $clipPath;
});
var InitialsLogo = exports.InitialsLogo = _styledComponents["default"].div.withConfig({
  displayName: "HBBrandAvatarstyles__InitialsLogo",
  componentId: "sc-1hj7ts0-2"
})(["background-color:", ";display:flex;align-items:center;justify-content:center;height:100%;width:100%;span{height:", ";font-size:", ";line-height:", ";color:", ";font-weight:600;text-transform:uppercase;}"], function (_ref6) {
  var $brandColor = _ref6.$brandColor;
  return $brandColor || _colors["default"].neutral500;
}, function (_ref7) {
  var $size = _ref7.$size;
  return $size === 'large' ? '33px' : 'auto';
}, function (_ref8) {
  var $size = _ref8.$size;
  return $size === 'large' ? '24px' : '15px';
}, function (_ref9) {
  var $size = _ref9.$size;
  return $size === 'large' ? '1.45' : '1.4';
}, function (_ref0) {
  var $brandColor = _ref0.$brandColor;
  return (0, _polished.readableColor)($brandColor !== null && $brandColor !== void 0 ? $brandColor : 'black', _colors["default"].black, _colors["default"].white);
});
var StyledStatusIndicator = exports.StyledStatusIndicator = _styledComponents["default"].div.withConfig({
  displayName: "HBBrandAvatarstyles__StyledStatusIndicator",
  componentId: "sc-1hj7ts0-3"
})(["position:absolute;background-color:", ";border-radius:50%;--indicator-size:", "px;width:var(--indicator-size);height:var(--indicator-size);top:calc(var(--indicator-size) / -2);right:calc(var(--indicator-size) / -2);"], function (_ref1) {
  var status = _ref1.status;
  return INDICATOR_COLORS[status];
}, STATUS_INDICATOR_SIZE);
//# sourceMappingURL=HBBrandAvatar.styles.js.map